"use strict";

exports.__esModule = true;
exports.aqicn = void 0;

var fetchBy_1 = require("./fetchBy");

var normalize_1 = require("./normalize");
/**
 * @see https://aqicn.org
 */


exports.aqicn = {
  fetchByGps: fetchBy_1.fetchByGps,
  fetchByStation: fetchBy_1.fetchByStation,
  id: 'aqicn',
  name: 'AQI CN',
  normalizeByGps: normalize_1.normalize,
  normalizeByStation: normalize_1.normalize
};